import { useDeepCompareEffect } from "@react-hookz/web";
import { useSetAtom } from "jotai";
import { useHydrateAtoms } from "jotai/utils";

import type { State } from "~/components/app-bar/atoms";
import { appBarAdSlotAtom } from "~/components/app-bar/atoms";

export const useAppBarAdSlot = (state: State) => {
  const setState = useSetAtom(appBarAdSlotAtom);
  useHydrateAtoms([[appBarAdSlotAtom, state]]);
  useDeepCompareEffect(() => {
    setState(state);
    return () => setState(null);
  }, [state, setState]);
};
